<div class="forbidden-container">
  <div class="forbidden-content">
    <h1 class="error-code">403</h1>
    <h2 class="error-title">{{ 'errors.permissionDenied' | translate }}</h2>
    <p class="error-message">{{ 'errors.permissionDeniedMessage' | translate }}</p>

    <div class="action-buttons">
      <button (click)="goHome()" class="btn-primary" data-testid="go-home-btn">
        {{ 'common.goHome' | translate }}
      </button>
    </div>
  </div>
</div>